import { render, staticRenderFns } from "./JdsReactionOption.vue?vue&type=template&id=095b7b56&scoped=true&"
import script from "./JdsReactionOption.vue?vue&type=script&lang=ts&"
export * from "./JdsReactionOption.vue?vue&type=script&lang=ts&"
import style0 from "./JdsReactionOption.vue?vue&type=style&index=0&id=095b7b56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095b7b56",
  null
  
)

export default component.exports